module.exports = __webpack_public_path__ + "static/media/curtain.1a144fb7.png";